import { Container } from "reactstrap";
import { Breadcrumbs, ToastContainer } from "../../components/Common/index";
import UserList from "./components/list/index";

const UsersPage = () => {
    document.title = "Operators";

    return (
        <div className="page-content">
            <Container fluid>
                <Breadcrumbs
                    title="Operators"
                />
                <UserList />
            </Container>
            <ToastContainer />
        </div>
    );
};

export default UsersPage;
